import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },
    warning: {
      backgroundColor: palette.superLightYellow,
      display: 'flex',
      alignItems: 'center',
      margin: '10px 10px 10px 0px',
      padding: '5px 5px 5px 2px',
      borderRadius: 8,
    },
    warningText: {
      fontSize: 12,
      fontWeight: 500,
      color: palette.superDarkYellow,
    },
    warningIcon: {
      color: palette.superDarkYellow,
      fontSize: 15,
      marginRight: 2,
    },
    actionsGrid: { display: 'flex', alignItems: 'center' },
    header: { marginTop: 16 },
    refreshButton: { padding: 0, margin: '0px 0px 0px 12px' },
  });
